var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtnExpand = function SvgBtnExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 39"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 38,
    x: 0.5,
    y: 0.5,
    fill: "var(--ielts-surface)",
    stroke: "var(--ielts-line)",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.92 22.053c-.773 1.319-2.68 1.319-3.453 0l-2.22-3.792c-.781-1.334.18-3.011 1.726-3.011h4.441c1.545 0 2.507 1.677 1.726 3.01z"
  })));
};
export default SvgBtnExpand;